import React, { useState, useEffect, Fragment } from 'react'
// ** Icons Imports
import { Button, Modal, ModalHeader, ModalBody, Form, Label, FormFeedback, Spinner, Input, Col, Row, ModalFooter } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import '@styles/react/libs/react-select/_react-select.scss'
// ** Utils
import { isObjEmpty, selectThemeColors, isUserLoggedIn } from '@utils'
import { useForm, Controller } from 'react-hook-form'
import Select, { components } from 'react-select'
import classnames from 'classnames'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useDispatch, useSelector } from "react-redux"
import { createWorkorder, getClearStoreData, ValidateWorkorderCreation, GetCompanyDetailsByName, CreateCompany, insertNewCompanyData } from '../../../../views/redux/store'
import ComponentSpinner from '../../../../components/spinner/Loading-spinner'
import { DefaultConfig } from '../../../../settings/config'
import CustomValueContainer from '../../../../views/Components/Select'

const msgStyles = {
  background: "#202a5b",
  color: "#ffffff",
  cursor: 'pointer'
}

const CreateWorkorder = ({ centerModal, closeModel, categoryId, typeId, valid }) => {
  const sorter = DefaultConfig().sorter
  const selectStyles = DefaultConfig().selectStyles
  const { woId } = useParams()
  const { catCode, typeCode } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const stores = useSelector((state) => state.commonreducerSlice)
  const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn())?.isEmployee
  const [centeredModal, setCenteredModal] = useState(centerModal)
  const [woTypeValue, setwoTypeData] = useState(null)
  const [woComValue, setCompanyVal] = useState(null)
  const [woCatValue, setwoCatData] = useState(null)
  const [woTypeOptions, setwoTypeOptions] = useState([])
  const [zspinnerStatus, setzspinnerStatus] = useState(false)
  const [duplicateErrorAlert, setDuplicateErrorAlert] = useState(false)
  const [dupData, setDupData] = useState('')
  const [zloader, setzloader] = useState(false)
  const [companyData, setCompanyData] = useState([])
  const [salesforce, setSalesforce] = useState('')

  const [addComModel, setAddCompany] = useState(false)
  const [salesearchBool, setSaleSearch] = useState(false)
  const [inputValue, setInputValue] = useState('')

  const [countryData, setCountryData] = useState(null)
  const [stateData, setStateData] = useState(null)
  const [companyId, setCompanyId] = useState(null)
  const [stateOptions, setStateOptions] = useState([])
  const [companyAddress, setCompanyAddress] = useState('')
  const [emailId, setEmailId] = useState('')
  const [errorEmail, setErrorEmail] = useState('')
  const [cityName, setCity] = useState('')
  const [postalCode, setPostalCode] = useState('')

  const [salCompanyBool, setSalCompanyBool] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [addCompanyOption, setAddCompanyOption] = useState(false)

  const [createLoader, setCreateLoader] = useState(false)
  // const [userCompanies, setUserCompanies] = useState([])
  // // const [placeHolderMessage, setPlaceHolderMessage] = useState(false)

  // // useEffect(() => {
  // //   const userData = JSON.parse(localStorage.getItem('userData'))
  // //   if (userData) {
  // //     const companyName = userData?.companyName
  // //     if (companyName && companyName.toLowerCase() === 'placeholder' && !isEmployee) {
  // //       setPlaceHolderMessage(true)
  // //     }
  // //   }
  // // }, [JSON.parse(localStorage.getItem('userData'))])

  // useEffect(() => {
  //   const userData = JSON.parse(localStorage.getItem('userData'))
  //   console.log(userData.companies, 'userData?.companies')
  //   const companyIds = userData?.companies?.map(company => company.companyId)
  //   setUserCompanies(companyIds)
  //   console.log(userCompanies, 'userCompanies')
  // }, [])

  useEffect(() => {
    setStateOptions([])
    if (countryData) {
      const states = countryData.states
      const statesData = []
      states.forEach((element) => {
        statesData.push({ value: element.stateCode, label: element.stateName })
      })
      setStateOptions(statesData)
    }
  }, [countryData])

  useEffect(() => {
    if (emailId) {
      if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(emailId)) {
        setErrorEmail('')
      } else {
        setErrorEmail('Email is invalid')
      }
    }
  }, [emailId])

  useEffect(() => {
    if (stores.woBool) {
      setCenteredModal(stores.woBool)
    }
  }, [stores.woBool])

  useEffect(() => {
    if (stores.checkwoData) {
      if (isEmployee || !isEmployee) {
        setDupData(stores.checkwoData)
        if (stores.checkwoData.workorderValidationMessage) {
          setDuplicateErrorAlert(true)
        } else {
          setDuplicateErrorAlert(false)
        }
      }
    }
  }, [stores.checkwoData])

  useEffect(() => {
    if (woCatValue) {
      const woCates = stores.woCates.length > 0 ? stores.woCates : []
      if (woCates.find(find => find.value === woCatValue.value)) {
        let woTypes = woCates.find(find => find.value === woCatValue.value).woTypes
        if (!isEmployee) {
          woTypes = woTypes.filter(find => find.isPublic === true)
        }
        if (woCatValue?.code === 'IHM') {
          setwoTypeOptions(woTypes.filter(find => find.code !== 'ICA'))
        } else {
          setwoTypeOptions(woTypes)
        }
      }
    }
  }, [woCatValue])

  // Get Company Details in salesforce
  useEffect(() => {
    if (isEmployee) {
      if (salesforce.length > 2) {
        setIsLoading(true)
        const timer = setTimeout(() => {
          const searchOptions = async () => {
            if (salesforce) {
              const responseData = await dispatch(GetCompanyDetailsByName(salesforce))
              const companyData = responseData.payload
              if (companyData) {
                const sfCompanys = []
                if (companyData.length > 0) {
                  companyData.forEach((item) => {
                    if (item.agentId__c) {
                      sfCompanys.push({ value: item.unique_Id__c, label: `${item.name} ${item.agentId__c !== null ? `(${item.agentId__c})` : ''}`, name: item.name, agentId: item.agentId__c })
                    }
                  })
                } else {
                  setAddCompanyOption(true)
                }
                setCompanyData(sfCompanys)
                setIsLoading(false)
              }
            }
          }
          if (salesforce) {
            setIsLoading(true)
            setAddCompanyOption(false)
            searchOptions()
          } else {
            setIsLoading(false)
            setCompanyData([])
          }
        }, 500)
        return () => clearTimeout(timer)
      } else {
        setIsLoading(false)
        setCompanyData([])
        setAddCompanyOption(false)
      }
    }
  }, [salesforce])

  useEffect(() => {
    if (!centeredModal) {
      dispatch(getClearStoreData())
      setwoCatData(null)
      setDuplicateErrorAlert(false)
      setwoTypeData(null)
      setwoTypeOptions([])
      dispatch(createWorkorder(false))
      closeModel(centeredModal)
      setCompanyVal(null)
    }
  }, [centeredModal])

  useEffect(() => {
    if (!addComModel) {
      setInputValue('')
      setCompanyAddress('')
      setCountryData(null)
      setStateData(null)
      setStateOptions([])
      setEmailId('')
      setCity('')
      setPostalCode('')
    }
  }, [addComModel])

  // ** Hooks
  const ValidSchema = yup.object().shape({
    [`wocateCompany`]: isEmployee && woTypeValue?.code !== "VI" ? yup.object().nullable().required("Company is a required field") : (!isEmployee ? yup.object().nullable().required("Company is a required field") : yup.object().nullable()),
    // [`wocateCompany`]: yup.object().nullable().required("Company is a required field").when("woTypeValue", () => {
    //   if (!isEmployee && woTypeValue && woTypeValue?.code === "VI") return yup.object().nullable().notRequired("Company is a required field")
    //   else return yup.object().nullable().required("Company is a required field")
    // }),
    [`wotypeSelect`]: yup.object().nullable().required("Work Order Type is a required field"),
    [`wocateSelect`]: yup.object().nullable().required("Work Order Category is a required field")
  })

  const { trigger, handleSubmit, control, reset, formState: { errors }, setValue } = useForm({ mode: 'onChange', resolver: yupResolver(ValidSchema) })

  const handleReset = () => {
    reset({
      wotypeSelect: null,
      wocateSelect: null,
      wocateCompany: null
    })
    setCompanyVal(null)
    setwoCatData(null)
    setwoTypeData(null)
    setwoTypeOptions([])
    setDuplicateErrorAlert(false)
  }

  useEffect(() => {
    if (categoryId && typeId && valid) {
      if (isEmployee) {
        setwoCatData(categoryId)
        setwoTypeData(typeId)
        setValue('wocateSelect', categoryId)
        setValue('wotypeSelect', typeId)
      }
    }
  }, [categoryId, typeId, valid])

  const onSubmit = async (values) => {
    let condition
    trigger()
    if (isObjEmpty(errors)) {
      dispatch(getClearStoreData())
      const dupDatas = ''
      if (!dupDatas) {
        setzspinnerStatus(true)
        sessionStorage.removeItem("companyData")
        const wocateSelect = values.wocateSelect
        const wotypeSelect = values.wotypeSelect
        const companyObj = values.wocateCompany
        const wocateCompany = { ...companyObj }
        const obj = {
          type: woTypeValue ? woTypeValue.code : null,
          categoryId: woCatValue ? woCatValue.code : null,
          companyId: companyId ? companyId : null
        }
        if (wocateCompany && companyId) {
          wocateCompany['value'] = companyId
          sessionStorage.setItem("companyData", JSON.stringify(wocateCompany))
        }
        // if ((woCatValue.code === 'IHM' && woTypeValue.code === 'SOC') || (woCatValue.code === 'ERB' && (woTypeValue.code === "SBI"))) {
        //   setzloader(false)
        //   setzspinnerStatus(true)
        //   setCenteredModal(!centerModal)
        //   if (woId) {
        //     navigate('/pageRefresh')
        //     setTimeout(() => {
        //       navigate(`/${wocateSelect.code}/${wotypeSelect.code}/save`)
        //     }, 2000)
        //   } else {
        //     navigate(`/${wocateSelect.code}/${wotypeSelect.code}/save`)
        //   }
        // } else {
        sessionStorage.removeItem("CreateIcaData")
        const responseData = await dispatch(ValidateWorkorderCreation(obj))
        if (responseData.payload) {
          sessionStorage.removeItem("CreateIcaData")
          const data = responseData.payload.data
          if (data && data.workorderValidationMessage === undefined) {
            const allCompanies = [...stores.allCompanies]
            const findCompany = allCompanies.find(find => find.value === wocateCompany?.value)
            if (!findCompany) {
              allCompanies.push({ value: wocateCompany?.value, label: wocateCompany?.name })
              dispatch(insertNewCompanyData(allCompanies))
            }
            condition = true
            if (woId || catCode) {
              setzloader(false)
              navigate('/pageRefresh')
              setTimeout(() => {
                if (data.woId && data.woId > 0) {
                  navigate(`/${wocateSelect.code}/${wotypeSelect.code}/${data.woId}`)
                } else {
                  navigate(`/${wocateSelect.code}/${wotypeSelect.code}/save`)
                }
              }, 2000)
            } else {
              setzloader(false)
              if (data.woId && data.woId > 0) {
                navigate(`/${wocateSelect.code}/${wotypeSelect.code}/${data.woId}`)
              } else {
                navigate(`/${wocateSelect.code}/${wotypeSelect.code}/save`)
              }
            }
          } else if (data.workorderValidationMessage) {
            setzspinnerStatus(false)
            setzloader(false)
            setDupData(data)
            setDuplicateErrorAlert(true)
          }
        }
        setzloader(false)
        // }
        if (condition === true) {
          setDuplicateErrorAlert(false)
          setDupData('')
          setCenteredModal(!centerModal)
        }
      }
    }
  }

  const ValidSchemas = yup.object().shape({
    [`companyAddress`]: yup.string().trim().nullable().required("Company Address is a required field"),
    [`country`]: yup.object().nullable().required("Country is a required field"),
    [`city`]: yup.string().trim().nullable().required("City is a required field"),
    [`state`]: yup.string().trim().nullable().required("State is a required field").when("country", () => {
      if (stateOptions.length > 0) {
        return yup.string().trim().nullable().required("State is a required field")
      } else {
        return yup.string().trim().nullable().notRequired("State is a required field")
      }
    }),
    [`emailId`]: yup.string().trim().nullable().required("Email is a required field"),
    [`postalCode`]: yup.string().trim().nullable().min(4, "Postal Code / Zip Code Must be between 4 to 8").max(8, "Postal Code / Zip Code Must be between 4 to 8").required("Postal Code / Zip Code is a required field")
  })

  const { trigger: trigger1, reset: reset1, handleSubmit: handleSubmit1, formState: { errors: errors1 }, control: control1 } = useForm({
    resolver: yupResolver(ValidSchemas),
    mode: "onChange"
  })

  const handleSaleReset = () => {
    reset1({
      companyAddress: null,
      country: null,
      state: null,
      city: null,
      emailId: null,
      postalCode: null
    })
    setCountryData(null)
    setStateData(null)
    setStateOptions([])
    setCompanyAddress('')
    setCity('')
    setPostalCode('')
    setEmailId('')
    setErrorEmail('')
    setInputValue('')
  }

  const onValueBlur = async (value) => {
    reset({ wocateCompany: null })
    setAddCompany(true)
    setInputValue(value)
    setSaleSearch(false)
  }

  async function fetchData() {
    setCreateLoader(true)
    const object = {}
    if (isEmployee) {
      object['AccountId'] = woComValue.value
    } else {
      object['companyId'] = woComValue.value
    }
    sessionStorage.setItem("sfAccountId", object['AccountId'])
    object['Name'] = encodeURIComponent(woComValue.name)
    object["AgentId"] = woComValue?.agentId
    object['BillingStreet'] = ''
    object['BillingCity'] = ''
    object['BillingState'] = ''
    object['BillingPostalCode'] = ''
    object['BillingCountry'] = ''
    object['Email__c'] = ''
    localStorage.setItem('agentId', JSON.stringify(woComValue?.agentId))
    const responseData = await dispatch(CreateCompany(object)).finally(() => {
      // setTimeout(() => {
      //   setCreateLoader(false)
      // }, 50)
    })
    const respData = responseData.payload
    sessionStorage.removeItem("CreateIcaData")
    if (respData) {
      setTimeout(() => {
        setCreateLoader(false)
      }, 50)
      setCompanyId(respData)
    } else {
      setCreateLoader(true)
      setAddCompany(false)
      setSaleSearch(false)
    }
    setzloader(false)
  }

  async function fetchCustomerData() {
    // setCreateLoader(true)
    const object = {}

    object['companyId'] = String(woComValue.value)
    object["AccountId"] = (woComValue.sfUniqueId) ? String(woComValue.sfUniqueId) : null

    sessionStorage.setItem("sfAccountId", object['companyId'])
    object['Name'] = encodeURIComponent(woComValue.name.replace(/\s*\(.*?\)\s*/g, '').trim())
    object["AgentId"] = String(woComValue?.agentId)
    object['BillingStreet'] = ''
    object['BillingCity'] = ''
    object['BillingState'] = ''
    object['BillingPostalCode'] = ''
    object['BillingCountry'] = ''
    object['Email__c'] = ''
    sessionStorage.removeItem("CreateIcaData")
    // const responseData = await dispatch(CreateCompany(object)).finally(() => {
    //   setTimeout(() => {
    //     setCreateLoader(false)
    //   }, 50)
    // })
    // const respData = responseData.payload
    // if (respData) {
    //   {
    //     setCompanyId(respData)
    //   }
    // } else {
    //   setAddCompany(false)
    //   setSaleSearch(false)
    // }
    setzloader(false)
  }

  useEffect(() => {
    if ((isEmployee ? woComValue : true) && woCatValue && woTypeValue) {
      // if (isEmployee) {
      //   setCompanyId(null)
      // }
      setzloader(true)
      if (isEmployee) {
        if (!woComValue.isCompany) {
          fetchData()
        }
      } else {
        setzloader(false)
      }
    }
  }, [woCatValue, woComValue, woTypeValue])

  useEffect(() => {
    if ((!isEmployee ? woComValue : true) && woCatValue && woTypeValue) {
      // if (!isEmployee) {
      //   setCompanyId(null)
      // }
      setzloader(true)
      if (!isEmployee) {
        fetchCustomerData()
      } else {
        setzloader(false)
      }
    }
  }, [woCatValue, woComValue, woTypeValue])

  const onAddSubmit = async (values) => {
    if (inputValue.trim().length === 0) {
      setSalCompanyBool(true)
      setInputValue('')
    }
    trigger1()
    if (isObjEmpty(errors1) && inputValue.trim().length > 0) {
      setSaleSearch(true)
      const object = {}
      // const userData = JSON.parse(localStorage.getItem('userData'))
      // object['AccountId'] = userData.acccuntId
      object['Name'] = inputValue
      object['BillingStreet'] = values.companyAddress
      object['BillingCity'] = values.city
      object['BillingState'] = values.state
      object['BillingPostalCode'] = values.postalCode
      object['BillingCountry'] = values.country ? values.country.label : null
      object['Email__c'] = values.emailId
      const responseData = await dispatch(CreateCompany(object))
      const respData = responseData.payload
      if (respData) {
        sessionStorage.removeItem("CreateIcaData")
        if (inputValue) {
          const compData = [...companyData]
          compData.push({ value: respData, label: inputValue, isCompany: true })
          setCompanyData(compData)
          setCompanyVal({ value: respData, label: inputValue, isCompany: true })
          setValue('wocateCompany', { value: respData, label: inputValue })
          setValue('wocateSelect', woCatValue)
          setValue('wotypeSelect', woTypeValue)
          setAddCompany(false)
          setSaleSearch(false)
          setSalesforce('')
        }
      } else {
        setAddCompany(false)
        setSaleSearch(false)
      }
    }
  }

  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        {addCompanyOption ? (
          <Fragment>
            {(woCatValue && woCatValue.code === 'IHM' && woTypeValue && woTypeValue.code === 'SOC') ? 'No Options' : <Fragment>
              <div onClick={() => onValueBlur(salesforce)} className='d-none'>  Add Company</div>  No Options
            </Fragment>
            }
          </Fragment>
        ) : (
          <div>Enter min 3 characters.</div>
        )}
      </components.NoOptionsMessage>
    )
  }

  const handleInputChange = (inputValue, action) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      setSalesforce(inputValue)
      setCompanyVal(null)
      setValue("wocateCompany", null)
    }
  }

  const addComModelClose = (value) => {
    setAddCompany(value)
    setValue('wocateSelect', woCatValue)
    setValue('wotypeSelect', woTypeValue)
  }

  useEffect(() => {
    if (!isEmployee) {
      // if (stores.allCompanies.length > 0) {
      //   setValue('wocateCompany', stores.allCompanies[0])
      //   setCompanyVal(stores.allCompanies[0])
      // }
      setCompanyData(stores.allCompanies)
    }
  }, [stores.allCompanies, stores.allCompanies.length])

  return (

    <div className='vertically-centered-modal'>
      <Modal isOpen={centeredModal} toggle={() => setCenteredModal(!centeredModal)} color='primary' className='modal-dialog-centered'>
        {(!stores.unauthorize && !isEmployee) ? (
          <Fragment>
            <ModalHeader toggle={() => setCenteredModal(!centeredModal)}>Create Work Order </ModalHeader>
            <ModalBody className='p-2'>
              <h5 style={{ fontSize: '16px' }}>Your account is not associated with any company. Please reach out to <span style={{ fontWeight: 'bold' }}>WPCloudSupport@liscr.com</span> to update your company details.</h5>
            </ModalBody>
            <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
              <Row>
                <Col sm='12' md='12' lg='12' xl='12' className='p-0'>
                  <div className='model_popup_panel model_popup_submit_btn' style={{ justifyContent: 'center' }}>
                    <Button className='me-1 reset_button_view' outline color='secondary' type='reset' onClick={() => setCenteredModal(!centeredModal)}>
                      Close
                    </Button>
                  </div>
                </Col>
              </Row>
            </ModalFooter>
          </Fragment>
        ) : (
          <Fragment>
            <ModalHeader toggle={() => setCenteredModal(!centeredModal)}>Create Work Order </ModalHeader>
            <Form onSubmit={handleSubmit(onSubmit)}>
              {!zloader ? (
                <Fragment>
                  <ModalBody className='p-2'>
                    <Row>
                      <Col sm='12' md='12' lg='12' xl='12'>
                        <div className='select_create my-2'>
                          <Controller
                            render={({ field: { onChange, ref } }) => (
                              <Select
                                id={`${catCode}_${typeCode}_wocateSelect`}
                                inputRef={ref}
                                classNamePrefix="select"
                                options={stores ? (stores.woCates.length > 0 ? stores.woCates : []) : []}
                                value={woCatValue}
                                onChange={(val) => {
                                  onChange(val, setwoCatData(val), setwoTypeData(null), setwoTypeOptions([]), setSalesforce(''), setCompanyVal(null), setCompanyData(isEmployee ? [] : stores.allCompanies), setValue('wotypeSelect', null), setValue('wocateCompany', null), setDuplicateErrorAlert(false))
                                  if (val && val?.value === woCatValue?.value) {
                                    setwoTypeOptions(woTypeOptions)
                                  }
                                }}
                                className={classnames('react-select', { 'is-invalid': errors['wocateSelect'] })}
                                isClearable
                                isOptionDisabled={(option) => option.disabled}
                                placeholder={`Select Work Order Category <span class='text-danger'>*</span>`}
                                styles={selectStyles}
                                components={{ ValueContainer: CustomValueContainer }}
                              />
                            )}
                            defaultValue={woCatValue}
                            control={control}
                            name='wocateSelect'
                            theme={selectThemeColors}
                          />
                          {errors.wocateSelect && <FormFeedback>{errors.wocateSelect.message}</FormFeedback>}
                        </div>
                      </Col>
                      <Col sm='12' md='12' lg='12' xl='12'>
                        <div className='select_create my-2'>
                          <Controller
                            render={({ field: { onChange, ref } }) => (
                              <Select
                                id={`${catCode}_${typeCode}_wotypeSelect`}
                                inputRef={ref}
                                classNamePrefix="select"
                                options={woTypeOptions}
                                value={woTypeValue}
                                onChange={val => {
                                  if (val?.code === "VI") {
                                    delete errors?.wocateCompany
                                  }
                                  onChange(val, setwoTypeData(val), setSalesforce(''), setCompanyVal(null), setCompanyData(isEmployee ? [] : stores.allCompanies), setValue('wocateCompany', null), setDuplicateErrorAlert(false))
                                }}
                                className={classnames('react-select', { 'is-invalid': errors['wotypeSelect'] })}
                                isClearable
                                isOptionDisabled={(option) => option.disabled}
                                placeholder={`Select Work Order Type <span class='text-danger'>*</span>`}
                                styles={selectStyles}
                                components={{ ValueContainer: CustomValueContainer }}
                              />
                            )}
                            defaultValue={woTypeValue}
                            control={control}
                            name='wotypeSelect'
                            theme={selectThemeColors}
                          />
                          {errors.wotypeSelect && <FormFeedback>{errors.wotypeSelect.message}</FormFeedback>}
                          {/* {!isEmployee &&
                            <Fragment>
                              {(duplicateErrorAlert && dupData) && <div className="invalid-feedback-error" dangerouslySetInnerHTML={{ __html: dupData.workorderValidationMessage }}></div>}
                            </Fragment>
                          } */}
                        </div>
                      </Col>
                      {isEmployee && woTypeValue?.code !== "VI" && (
                        <Col sm='12' md='12' lg='12' xl='12'>
                          <div className='select_create my-2'>
                            <Controller
                              render={({ field: { onChange, ref } }) => (
                                <Select
                                  id={`${catCode}_${typeCode}_wocateCompany`}
                                  inputValue={salesforce}
                                  inputRef={ref}
                                  classNamePrefix="select"
                                  options={companyData}
                                  filterOption={(option) => {
                                    const normalizedOption = option.label.toLowerCase().replace(/[^a-z0-9]/g, '')
                                    return normalizedOption
                                  }}
                                  value={woComValue}
                                  onChange={val => {
                                    onChange(val)
                                    setCompanyVal(val)
                                    setDuplicateErrorAlert(false)
                                  }}
                                  className={classnames('react-select', { 'is-invalid': errors['wocateCompany'] })}
                                  isClearable
                                  components={{ NoOptionsMessage, ValueContainer: CustomValueContainer }}
                                  styles={
                                    addCompanyOption && !(woCatValue && woCatValue.code === 'IHM' && woTypeValue && woTypeValue.code === 'SOC') ? {
                                      ...selectStyles,
                                      noOptionsMessage: base => ({ ...base, ...msgStyles })
                                    } : selectStyles
                                  }
                                  onInputChange={handleInputChange}
                                  isLoading={isLoading}
                                  loadingMessage={() => 'Loading...'}
                                  isDisabled={!woTypeValue}
                                  placeholder={`Select Company <span class='text-danger'>*</span>`}
                                // required={woTypeValue?.code !== "VI"}
                                />
                              )}
                              defaultValue={woComValue}
                              control={control}
                              name='wocateCompany'
                              theme={selectThemeColors}
                            />
                            {errors.wocateCompany && <FormFeedback>{errors.wocateCompany.message}</FormFeedback>}
                            {(duplicateErrorAlert && dupData) && (
                              <div className="invalid-feedback-error" dangerouslySetInnerHTML={{ __html: dupData.workorderValidationMessage }}></div>
                            )}
                          </div>
                        </Col>
                      )}

                      {!isEmployee &&
                        <Col sm='12' md='12' lg='12' xl='12'>
                          <div className='select_create my-2'>
                            <Controller
                              render={({ field: { onChange, ref } }) => (
                                <Select
                                  id={`${catCode}_${typeCode}_wocateCompany`}
                                  inputValue={salesforce}
                                  inputRef={ref}
                                  classNamePrefix="select"
                                  options={companyData}
                                  value={woComValue}
                                  onChange={val => { onChange(val, setCompanyVal(val), setCompanyId(val ? val.value : null), setDuplicateErrorAlert(false)) }}
                                  className={classnames('react-select', { 'is-invalid': errors['wocateCompany'] })}
                                  isClearable
                                  components={{ NoOptionsMessage, ValueContainer: CustomValueContainer }}
                                  styles={((addCompanyOption) && { noOptionsMessage: base => ({ ...base, ...msgStyles }) }, selectStyles)}
                                  onInputChange={handleInputChange}
                                  isLoading={isLoading}
                                  loadingMessage={() => 'Loading...'}
                                  isDisabled={!woTypeValue}
                                  placeholder={`Select Company <span class='text-danger'>*</span>`}
                                />
                              )}
                              defaultValue={woComValue}
                              control={control}
                              name='wocateCompany'
                              theme={selectThemeColors}
                            />
                            {errors.wocateCompany && <FormFeedback>{errors.wocateCompany.message}</FormFeedback>}
                            {(duplicateErrorAlert && dupData) && <div className="invalid-feedback-error" dangerouslySetInnerHTML={{ __html: dupData.workorderValidationMessage }}></div>}
                          </div>
                        </Col>
                      }
                    </Row>
                  </ModalBody>
                  <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
                    <Row>
                      <Col sm='12' md='12' lg='12' xl='12' className='p-0'>
                        <div className='model_popup_panel model_popup_submit_btn' style={{ justifyContent: 'center' }}>
                          {zspinnerStatus === true ? (
                            <Button.Ripple color='primary' disabled={zspinnerStatus}>
                              <Spinner size='sm' />
                              <span className='mx-50'>Loading...</span>
                            </Button.Ripple>
                          ) : (
                            <Fragment>
                              <Button className='me-1 reset_button_view' outline color='secondary' type='reset' onClick={handleReset}>
                                Reset
                              </Button>
                              {isEmployee ? (
                                <Button className='create_submit_btn' type='submit' disabled={duplicateErrorAlert || createLoader}>
                                  Submit
                                </Button>
                              ) : (
                                <Button className='create_submit_btn' type='submit' disabled={duplicateErrorAlert}>
                                  Submit
                                </Button>
                              )}
                            </Fragment>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </ModalFooter>
                </Fragment>
              ) : (
                <ComponentSpinner />
              )}
            </Form>
          </Fragment>
        )}

      </Modal>

      <Modal isOpen={addComModel} toggle={() => addComModelClose(!addComModel)} className='modal-dialog-centered modal-dialogs'>
        <ModalHeader toggle={() => addComModelClose(!addComModel)}>Add Company </ModalHeader>
        <ModalBody>
          {!salesearchBool ? (
            <Form onSubmit={handleSubmit1(onAddSubmit)}>
              <div className='model_workorder_warppers'>
                <Row>
                  <Col sm='12' md='12' lg='12' xl='12' className='Workorder_Category_rows'>
                    <Label className='form-label' for='saleCompany'>
                      Company Name <span className='text-danger'>*</span>
                    </Label>
                    <Controller
                      control={control1}
                      id='Company Name'
                      name='Company Name'
                      render={({ field: { onChange } }) => <Input placeholder='' invalid={errors1.inputValue && true} defaultValue={inputValue} value={inputValue}
                        id={`${catCode}_${typeCode}_CompanyName`} onChange={(val) => { onChange(val, setInputValue(val.target.value)) }} />}
                    />
                    {(salCompanyBool) ? <span className='errorMessage'>Company is a required field</span> : ''}
                  </Col>
                  <Col sm='12' md='12' lg='12' xl='12' className='Workorder_Category_rows'>
                    <Label className='form-label' for='companyAddress'>
                      Company Address  <span className='text-danger'>*</span>
                    </Label>
                    <Controller
                      control={control1}
                      id='companyAddress'
                      name='companyAddress'
                      render={({ field: { onChange } }) => <Input
                        id={`${catCode}_${typeCode}_companyAddress`}
                        type='textarea'
                        rows='2'
                        placeholder=''
                        invalid={errors1.companyAddress && true}
                        value={companyAddress}
                        onChange={(val) => { onChange(val, setCompanyAddress(val.target.value)) }} />}
                    />
                    {errors1.companyAddress && <FormFeedback>{errors1.companyAddress.message}</FormFeedback>}
                  </Col>
                  <Col sm='12' md='6' lg='6' xl='6' className='Workorder_Category_rows'>
                    <Label className='form-label' for='country'>
                      Country <span className='text-danger'>*</span>
                    </Label>
                    <Controller
                      render={({ field: { onChange, ref } }) => (
                        <Select
                          id={`${catCode}_${typeCode}_country`}
                          inputRef={ref}
                          classNamePrefix="select"
                          placeholder="Select Country"
                          options={stores ? sorter("label", "asc", [...stores.countryStates]) : []}
                          value={countryData}
                          onChange={(val) => { onChange(val, setCountryData(val)) }}
                          className={classnames('react-select', { 'is-invalid': errors1['country'] })}
                          isClearable
                        />
                      )}
                      control={control1}
                      name='country'
                      theme={selectThemeColors}
                    />
                    {errors1.country && <FormFeedback>{errors1.country.message}</FormFeedback>}
                  </Col>
                  <Col sm='12' md='6' lg='6' xl='6' className='Workorder_Category_rows'>
                    {(stateOptions.length > 0) &&
                      <Label className='form-label' for='state'>
                        State <span className='text-danger'>*</span>
                      </Label>
                    }
                    {stateOptions.length > 0 ? (
                      <Fragment>
                        <Controller
                          render={({ field: { onChange, ref } }) => (
                            <Select
                              id={`${catCode}_${typeCode}_state`}
                              inputRef={ref}
                              classNamePrefix="select"
                              placeholder="Select State"
                              options={sorter("label", "asc", [...stateOptions])}
                              value={stateData}
                              onChange={(val) => { onChange(val ? val.label : '', setStateData(val)) }}
                              className={classnames('react-select', { 'is-invalid': errors1['state'] })}
                              isClearable
                            />
                          )}
                          control={control1}
                          name='state'
                          theme={selectThemeColors}
                        />
                        {errors1.state && <FormFeedback>{errors1.state.message}</FormFeedback>}
                      </Fragment>
                    ) : (
                      <div style={{ display: 'none' }}>
                        <Controller
                          control={control1}
                          id='state'
                          name='state'
                          render={({ field: { onChange } }) => <Input placeholder='' invalid={errors1.state && true} value={stateData}
                            id={`${catCode}_${typeCode}_state`} onChange={(val) => { onChange(val, setStateData(val.target.value)) }} disabled />}
                        />
                      </div>
                    )}
                  </Col>
                  <Col sm='12' md='6' lg='6' xl='6' className='Workorder_Category_rows'>
                    <Label className='form-label' for='city'>
                      City <span className='text-danger'>*</span>
                    </Label>
                    <Controller
                      control={control1}
                      id='city'
                      name='city'
                      render={({ field: { onChange } }) => <Input placeholder='' invalid={errors1.city && true} value={cityName}
                        id={`${catCode}_${typeCode}_city`} onChange={(val) => { onChange(val, setCity(val.target.value)) }} />}
                    />
                    {errors1.city && <FormFeedback>{errors1.city.message}</FormFeedback>}
                  </Col>
                  <Col sm='12' md='6' lg='6' xl='6' className='Workorder_Category_rows'>
                    <Label className='form-label' for='postalCode'>
                      Post Code / Zip Code <span className='text-danger'>*</span>
                    </Label>
                    <Controller
                      control={control1}
                      id='postalCode'
                      name='postalCode'
                      render={({ field: { onChange } }) => <Input placeholder='' invalid={errors1.postalCode && true} value={postalCode}
                        id={`${catCode}_${typeCode}_postalCode`} onChange={(val) => { onChange(val, setPostalCode(val.target.value)) }} />}
                    />
                    {errors1.postalCode && <FormFeedback>{errors1.postalCode.message}</FormFeedback>}
                  </Col>
                  <Col sm='12' md='6' lg='6' xl='6' className='Workorder_Category_rows'>
                    <Label className='form-label' for='emailId'>
                      Email <span className='text-danger'>*</span>
                    </Label>
                    <Controller
                      control={control1}
                      id='emailId'
                      name='emailId'
                      render={({ field: { onChange } }) => (
                        <Input
                          id={`${catCode}_${typeCode}_emailId`}
                          placeholder=''
                          invalid={errors1.emailId && true}
                          value={emailId}
                          onChange={(val) => { onChange(val, setEmailId(val.target.value)) }}
                        />
                      )}
                    />
                    {errors1.emailId && <FormFeedback>{errors1.emailId.message}</FormFeedback>}
                    {(errorEmail && !errors1.emailId) ? <span className='errorMessage'>{errorEmail}</span> : ''}
                  </Col>
                </Row>
              </div>
              <div className='model_popup_panel model_popup_submit_btn' style={{ justifyContent: 'center' }}>
                {zspinnerStatus === true ? (
                  <Button.Ripple color='primary' disabled={zspinnerStatus}>
                    <Spinner size='sm' />
                    <span className='mx-50'>Loading...</span>
                  </Button.Ripple>
                ) : (
                  <Fragment>
                    <Button className='me-1 reset_button_view' outline color='secondary' type='reset' onClick={handleSaleReset}>
                      Reset
                    </Button>
                    <Button className='create_submit_btn' type='submit' disabled={zloader}>
                      Submit
                    </Button>
                  </Fragment>
                )}
              </div>
            </Form>
          ) : (<ComponentSpinner />)}
        </ModalBody>
      </Modal>
    </div>
  )
}
export default CreateWorkorder
